'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (err) {
  var extras = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var hasRaven = window && window.Raven && typeof window.Raven.captureException === 'function' && typeof window.Raven.captureMessage === 'function';

  if (hasRaven) {
    window.Raven.captureException(err, extras);
  }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-public/static-1.53/js/helpers/reportError.js
// module id = 1258
// module chunks = 3